import React, { useState } from "react";
import {
  Button,
  Form,
  Container,
  Row,
  Col,
  Alert,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import "./LoginPage.css";
import LeftImage from "../assets/coozmoo-image.png";
import Logo from "../assets/logo_1.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");

    if (!username || !password) {
      setError("Please enter your username and password");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        "https://api.performancedashboard.io/api/metricool/auth/login",
        { username, password },
        { withCredentials: true }
      );


      const data = response.data;



      localStorage.setItem("username", data?.username);
      localStorage.setItem("userid", data?.id);
      localStorage.setItem("authToken", data?.token);
      localStorage.setItem("userRole", data?.role);
      localStorage.setItem("autologinUrl", data?.brands[0]?.autologin_url || "");
      localStorage.setItem("brands", JSON.stringify(data?.brands));

      if (data?.brands?.length > 0) {
        localStorage.setItem("autologinUrl", data?.brands[0]?.autologin_url);
        localStorage.setItem("brands", JSON.stringify(data?.brands));
      }

      if (data.role === "super_admin") {
        localStorage.setItem("userRole", data.role);
        window.location.href = "/dashboard";
      } else {
        localStorage.setItem("userRole", data.role);
        window.location.href = "/dashboard";
      }


    } catch (err: any) {
      setError(err.response?.data?.message || "Login failed");
    }
    finally {
      setLoading(false);
    }
  };

  const ToggleIcon = showPassword ? FaEyeSlash : FaEye;

  return (
    <Container fluid className="login-page">
      <Row className="min-vh-100 no-gutters">
        <Col
          xs={0}
          md={9}
          className="login-left d-none d-md-flex align-items-center justify-content-center"
        >
          <img src={LeftImage} alt="Illustration" className="left-illustration" />
        </Col>

        <Col
          xs={12}
          md={3}
          className="login-right d-flex align-items-center justify-content-center"
        >
          <div className="login-content">
            <div className="text-center mb-3" >
              <img src={Logo} alt="Logo" className="login-logo" />
              <h5 className="mt-2">Welcome</h5>
              <p className="text-muted">Login with Coozmoo</p>
            </div>

            {error && <Alert variant="danger">{error}</Alert>}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Email"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <InputGroup>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <Button
                    variant="outline-secondary"
                    type="button"
                    id="togglePassword"
                    onClick={() => setShowPassword((s) => !s)}
                    className="password-toggle-btn"
                  >
                    {React.createElement(ToggleIcon as any)}
                  </Button>
                </InputGroup>
              </Form.Group>

              <div className="d-grid mt-3">
                <Button type="submit" variant="primary" size="lg" disabled={loading}>
                  {loading ? <Spinner animation="border" size="sm" /> : "Login"}
                </Button>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginPage;
